export enum SelectedFacetWithLabel {
  isColored = 'isColoured',
  flexibleTemples = 'flexibleTemples',
  caseIncluded = 'caseIncluded',
  polarize = 'polarize',
  gradial = 'gradial',
  mirrored = 'mirrored',
  prescription = 'prescription',
  vtoReady = 'vtoReady',
  framesSize ='frameWidth',
  lensWidth = 'lensWidth',
  noseSize = 'noseSize'
}

export enum FramesSizeFilter {
  framesSize ='frameWidth',
  lensWidth = 'lensWidth',
  noseSize = 'noseSize'
}
